import React, { useEffect, useState } from 'react';
import './GamificationToast.css';

export function showGamificationToast(payload) {
  if (!payload?.awarded) return;
  window.dispatchEvent(new CustomEvent('qnaread:gamification-toast', { detail: payload }));
}

export default function GamificationToastHost() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setToast(e.detail);
      window.setTimeout(() => setToast(null), 4500);
    };
    window.addEventListener('qnaread:gamification-toast', handler);
    return () => window.removeEventListener('qnaread:gamification-toast', handler);
  }, []);

  if (!toast?.awarded) return null;

  const leveledUp = toast.level > toast.previousLevel;

  return (
    <div className="lg-toast" role="status" aria-live="polite">
      <p className="lg-toast-xp">+{toast.xpDelta} XP</p>
      {leveledUp && (
        <p className="lg-toast-level">Level {toast.previousLevel} → {toast.level}</p>
      )}
      {toast.achievementsUnlocked?.length > 0 && (
        <p className="lg-toast-ach">Achievement unlocked</p>
      )}
    </div>
  );
}
